import Button from 'components/Button';

import trashIcon from '/trashHelp.svg';

interface Props {
  title: string;
  text: string;
  onSaveClick: () => void;
  onCancelClick?: () => void;
  saveBtnText: string;
  cancelBtnText?: string;
}

const Modal = ({
  title,
  text,
  onSaveClick,
  onCancelClick,
  cancelBtnText,
  saveBtnText,
}: Props) => (
  <div className="fixed z-50 top-0 left-0 right-0 bottom-0 bg-[rgba(0,0,0,0.5)] flex items-center justify-center h-screen w-screen">
    <div className="bg-white p-8 md:p-4 rounded-2xl flex w-[500px] flex-col items-center max-w-96 md:max-w-80 text-center">
      <div
        className="flex justify-end items-end w-full cursor-pointer"
        onClick={onCancelClick}
      >
        <img src={trashIcon} alt="" />
      </div>
      <div className="text-2xl font-bold md:text-lg mb-3 text-black">
        {title}
      </div>
      <div className="text-secondaryText mb-6">{text}</div>
      <div
        className={`flex items-center ${
          cancelBtnText ? 'justify-between' : 'justify-center'
        }  w-full`}
      >
        {cancelBtnText && (
          <Button
            onClick={onCancelClick}
            className="w-6/12 mr-2"
            btnType="secondary"
          >
            {cancelBtnText}
          </Button>
        )}
        <Button onClick={onSaveClick} className="w-6/12">
          {saveBtnText}
        </Button>
      </div>
    </div>
  </div>
);

export default Modal;
